import { render, staticRenderFns } from "./OverWhy.vue?vue&type=template&id=166a3e6e&"
import script from "./OverWhy.vue?vue&type=script&lang=js&"
export * from "./OverWhy.vue?vue&type=script&lang=js&"
import style0 from "./OverWhy.vue?vue&type=style&index=0&id=166a3e6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoursesWhy: require('/opt/build/repo/components/Courses/Why.vue').default})
